import {SDrawerOrModal, SLowcodeList} from "shj-components";
import {config} from "./config.tsx";
import {getTrackPlanPage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useEffect, useRef} from "react";
import {message} from "antd";
import dayjs from "dayjs";

export const ChooseCustomer = (props) => {
  const {open, onClose, fn} = props;
  const listRef = useRef()

  useEffect(() => {
    if (open) {
      listRef.current?.clearSelectedRowKeys()
    }
  }, [open]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getTrackPlanPage({params: {pageId: current, pageSize}, data: query}).then(res => {
        resolve(apiData2Table(res))
      }).catch(e => {
        reject(e)
      })
    })
  }

  const onSubmit = () => {
    const [_, rows] = listRef?.current?.getSelectedRows()
    if(rows?.length <= 0 ){
      return message.error('请至少选择一条数据')
    }
    fn({...rows[0], handoverDate: dayjs(rows[0]?.handoverDate)})
    onClose()
  }

  const extension = {
    request: {fetchList}
  }

  return <SDrawerOrModal
      open={open}
      mode={'drawer'}
      title={'选择客户'}
      onCancel={onClose}
      onOk={onSubmit}
      okText={'确定'}
      width={1000}
  >
    <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extension}/>
  </SDrawerOrModal>
}